import apiClient from './apiClient';

// Extended timeout for audit trail queries (large datasets)
const AUDIT_TRAIL_TIMEOUT = 120000; // 120 seconds

class AuditService {
  // Get audit trail with optional filters
  async getAuditTrail(filters = {}) {
    try {
      const params = new URLSearchParams();
      
      if (filters.entityType) params.append('entityType', filters.entityType);
      if (filters.entityId) params.append('entityId', filters.entityId);
      if (filters.action) params.append('action', filters.action);
      if (filters.performedBy) params.append('performedBy', filters.performedBy);
      if (filters.startDate) params.append('startDate', filters.startDate);
      if (filters.endDate) params.append('endDate', filters.endDate);
      if (filters.limit) params.append('limit', filters.limit);
      if (filters.page) params.append('page', filters.page);
      if (filters.search) params.append('search', filters.search);

      const response = await apiClient.get(
        `/audit/formatted/logs${params.toString() ? `?${params.toString()}` : ''}`,
        { timeout: AUDIT_TRAIL_TIMEOUT }
      );
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Get audit trail error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch audit trail'
      };
    }
  }

  // Get formatted audit history for a specific entity
  async getFormattedEntityHistory(entityType, entityId, limit = 50) {
    try {
      const response = await apiClient.get(`/audit/formatted/entity/${entityType}/${entityId}?limit=${limit}`);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Get formatted entity history error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch entity history'
      };
    }
  }

  // Get audit history for a specific entity
  async getEntityHistory(entityType, entityId, limit = 50) {
    try {
      const response = await apiClient.get(`/audit/entity/${entityType}/${entityId}?limit=${limit}`);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Get entity history error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch entity history'
      };
    }
  }

  // Get user activity
  async getUserActivity(userId, limit = 50) {
    try {
      const response = await apiClient.get(`/audit/user/${userId}/activity?limit=${limit}`);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Get user activity error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch user activity'
      };
    }
  }

  // Get audit statistics
  async getAuditStats() {
    try {
      const response = await apiClient.get('/audit/stats');
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Get audit stats error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch audit statistics'
      };
    }
  }
}

export default new AuditService();